// The build carries the API, websocket, driver app and landing URLs of one domain (.env.*). When the
// planner is served from another domain, the FOJW names follow the page: fojw.routet.it talks to
// api-fojw.routet.it and websockets-fojw.routet.it and links to dwa-fojw.routet.it, whatever domain the
// build was made for (routetitan.io was lost on 20 Oct 2026; routetitan.com and routet.it both serve).
// Only FOJW hosts (first label contains "fojw") move, and only while the page is on one: Pelias
// (p.routetitan.com), tracking (my.routetitan.com) and third parties keep their URL, as do localhost and IPs.
const FOJW_LABEL = /fojw/i;

export const pageDomain = hostname => {
  if (!hostname || /^[0-9.]+$/.test(hostname)) return null;
  const labels = hostname.split(".");
  if (labels.length < 3) return null;
  return labels.slice(1).join(".");
};

const fojwDomain = hostname =>
  hostname && FOJW_LABEL.test(hostname.split(".")[0])
    ? pageDomain(hostname)
    : null;

export const swapDomain = (url, hostname) => {
  const domain = fojwDomain(hostname);
  const match = url && /^([a-z]+:\/\/)([^/?#:]+)(.*)$/i.exec(url);
  if (!domain || !match) return url;
  const [, scheme, host, rest] = match;
  const urlDomain = fojwDomain(host);
  if (!urlDomain || urlDomain === domain) return url;
  return `${scheme}${host.split(".")[0]}.${domain}${rest}`;
};

const pageHostname = () =>
  typeof window !== "undefined" && window.location
    ? window.location.hostname
    : "";

export const pageUrl = url => swapDomain(url, pageHostname());
